var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24 / basic / home"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.90715 8.33317L9.90825 3.33206L14.9094 8.33317H14.9083V16.6665H4.90826V8.33317H4.90715ZM3.2416 9.99872L2.01092 11.2294L0.833252 10.0517L8.73074 2.15425C9.38106 1.50392 10.4354 1.50392 11.0858 2.15425L18.9833 10.0517L17.8056 11.2294L16.5749 9.99874V16.6665C16.5749 17.587 15.8287 18.3332 14.9083 18.3332H4.90826C3.98779 18.3332 3.2416 17.587 3.2416 16.6665V9.99872Z",
    fill: "#2B391C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.d66453f0289da169cb54e75b2b3b64cb.svg";
export { ForwardRef as ReactComponent };